import { Dialog, DialogContent } from "../ui/dialog";
import { Button } from "../ui/button";
import { GOOD_DATA_FIELD_LABELS } from "../../lib/finish-profile";

interface FinishProfileModalProps {
  open: boolean;
  /** GOOD-DATA field keys the platform assumed during the chat-door intake. */
  fields: string[];
  onComplete: () => void;
  onDismiss: () => void;
}

/**
 * FinishProfileModal — post-signup nudge shown once on the first authenticated
 * dashboard load (SILL-398). The chat door collects the KEY tier and lets the
 * user early-eject; the platform assumes neutral defaults for the GOOD-DATA
 * fields they skipped. This modal tells the user exactly what was assumed and
 * routes them to replace it with real numbers.
 */
export function FinishProfileModal({
  open,
  fields,
  onComplete,
  onDismiss,
}: FinishProfileModalProps) {
  if (fields.length === 0) return null;

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onDismiss();
      }}
    >
      <DialogContent
        title="Finish your profile"
        description="To get you a number fast, we filled in a few estimates. Add your real details to sharpen your readiness — it only takes a minute."
      >
        <ul className="space-y-2">
          {fields.map((field) => (
            <li
              key={field}
              className="flex items-center gap-3 rounded-2xl bg-background px-4 py-3 text-sm text-foreground"
            >
              <span
                className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary"
                aria-hidden
              />
              {GOOD_DATA_FIELD_LABELS[field] ?? field}
            </li>
          ))}
        </ul>

        <div className="mt-6 flex flex-col gap-2 sm:flex-row-reverse">
          <Button className="w-full sm:w-auto" onClick={onComplete}>
            Complete profile
          </Button>
          <Button
            variant="ghost"
            className="w-full sm:w-auto"
            onClick={onDismiss}
          >
            Maybe later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
